import { useState } from "react";
import { Form, Input, Button, Modal, message } from "antd";
import { showErrorToast } from "helpers/utils";
import { TUser } from "api/services/models/types";
import { useTDAuthentication } from "auth/AuthenticationProvider";
import { triggerDeviceAction } from "api/services/NotificationService";
import { DeviceActionType, TNotificationDeviceAction } from "api/services/models/notification.types";

type TDictationIdFormProps = {
  user: TUser;
  onClose: () => void;
};

const DictationIdForm = ({ user, onClose }: TDictationIdFormProps) => {
  const { accountId } = useTDAuthentication();
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(true);
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);



  const handleFieldsChange = () => {
    const hasErrors = form
      .getFieldsError()
      .some(({ errors }) => errors.length > 0);
    const values = form.getFieldsValue();
    const hasEmpty = Object.values(values).some(
      (v) => v === undefined || v === ""
    );
    
    setDisabled(hasErrors || hasEmpty);
  };

  const onFinish = async (value: any) => {
    console.log("Submitted dictation ID:", value);
    if (!value) {
      showErrorToast("Please enter the dictation ID.");
      return;
    }
    const notificationDeviceAction: TNotificationDeviceAction = {
      accountId: accountId!,
      userId: user.userId,
      deviceActionType: DeviceActionType.UploadDictationById,
      dictationId: value.dictationId,
    };
    console.log("notificationDeviceAction", notificationDeviceAction);
    try {
      setLoading(true);
      const response = await triggerDeviceAction(notificationDeviceAction).finally(() => setLoading(false));
      console.log("response", response);
      message.info(response.data.message);
    } catch (err: any) {
      console.log(err);
      message.error(err.message);
      return;
    }
    onClose();
  };
  
  return (
    <Modal
        centered={true}
        open={true}
        onCancel={() => onClose()}
        footer={null}
        closable={false}
        width={400}
        loading={loading}
        >
    <Form
      form={form}
      name="dictation-id_form"
      layout="vertical"
      onFinish={onFinish}
      autoComplete="off"
      onFieldsChange={handleFieldsChange}
    >
      <Form.Item
        label="Enter Dictation ID"
        name="dictationId"
        rules={[
          { required: true, message: "Please enter the dictation ID" },
        ]}
      >
      <Input
        value={value}
        inputMode="numeric"
        onChange={e => {
          const numeric = e.target.value.replace(/\D/g, "");
          setValue(numeric);
        }}
        style={{ width: "100%" }}
      />
          
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" disabled={disabled}>
          Submit
        </Button>
      </Form.Item>
    </Form>
    </Modal>
  );
};

export default DictationIdForm;
